import type { ProductType } from '../ProductCard/ProductCardTypes'

export function reorderingProductBySku(filterProducts: ProductType[]) {
  const newProduct: ProductType[] = []

  filterProducts?.forEach((product) => {
    const ProductQuantity = product?.offers?.offers?.[0]?.quantity
    const itemLowPrice = product?.isVariantOf?.hasVariant?.reduce(
      (prev, curr) => {
        if (
          (prev?.offers?.offers?.[0]?.availability ===
            'https://schema.org/InStock' &&
            curr?.offers?.offers?.[0]?.price >=
              prev?.offers?.offers?.[0]?.price) ||
          curr?.offers?.offers?.[0]?.availability ===
            'https://schema.org/OutOfStock'
        ) {
          return prev
        }

        return curr
      }
    )

    product?.isVariantOf?.hasVariant?.some((item, index) => {
      if (
        item?.offers?.offers?.[0]?.availability ===
          'https://schema.org/InStock' &&
        itemLowPrice?.sku === item?.sku
      ) {
        newProduct?.push({
          ...product,
          sku: item?.sku,
          name: item?.name,
          additionalProperty: item?.additionalProperty,
          offers: {
            lowPrice: item?.offers?.offers?.[0]?.price,
            offers: [
              {
                availability: item?.offers?.offers?.[0]?.availability,
                price: item?.offers?.offers?.[0]?.price,
                listPrice: item?.offers?.offers?.[0]?.listPrice,
                quantity: ProductQuantity,
                seller: item?.offers?.offers?.[0]?.seller,
              },
            ],
          },
        })

        return true
      }

      if (index === product?.isVariantOf?.hasVariant?.length - 1) {
        newProduct?.push(product)

        return true
      }

      return false
    })
  })

  return newProduct
}

export function gridOrderByStock(filterProducts: ProductType[]) {
  const outOfStockProducts = filterProducts.filter(
    (productItem) =>
      productItem.offers?.offers?.[0]?.availability ===
        'https://schema.org/OutOfStock' &&
      !productItem.isVariantOf.hasVariant.some(
        (variantItem) =>
          variantItem.offers.offers[0].availability !==
          'https://schema.org/OutOfStock'
      )
  )

  const inStockProducts = filterProducts.filter(
    (productItem) =>
      productItem.offers?.offers?.[0]?.availability !==
        'https://schema.org/OutOfStock' ||
      productItem.isVariantOf.hasVariant.some(
        (variantItem) =>
          variantItem.offers.offers[0].availability !==
          'https://schema.org/OutOfStock'
      )
  )

  return [...inStockProducts, ...outOfStockProducts]
}

export function waitForElementById(
  id: string,
  timeout = 5000
): Promise<HTMLElement> {
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver((_mutations, obs) => {
      const element = document.getElementById(id)

      if (element) {
        obs.disconnect()
        resolve(element)
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    setTimeout(() => {
      observer.disconnect()
      reject(new Error(`Element with ID ${id} not found within ${timeout}ms`))
    }, timeout)
  })
}
